import { dispatch, useSelector } from '@/lib/store'
import {
  ADD_PRODUCT_IN_CART_API,
  CART_LIST_API,
  CART_RESTORE_API,
  DELETE_CART_API,
} from './apiConstants'
import { consumerRequest } from './request'
import { updateCityData } from '@/lib/reducers/cityReducer'
import { isEmpty, isNonCityRoute } from '@/utils/commonFunc'
import { loadState, saveState } from '@/utils/localStorage'
import useCustomToast from '@/hooks/useCustomToast'
import { eventConstants, trackEvent } from '@/utils/events'
import {
  CONSUMER_WEB_PLATFORM,
  CURRENT_SUBSIDIARY,
  INSERT_ACTION,
} from '@/utils/constants'

// Compared as strings because the cart API returns numeric ids while some
// product sources (e.g. the PDP endpoint) send them as strings. Searches every
// patient's cart, not just the first.
export const isProductInCart = (
  cartDtoList: any[] | null | undefined,
  productId: string | number | null | undefined
): boolean => {
  if (productId === null || productId === undefined || productId === '')
    return false
  const targetId = String(productId)
  return (cartDtoList || []).some((cart: any) =>
    (cart?.productDtoList || []).some(
      (item: any) => item?.id != null && String(item.id) === targetId
    )
  )
}

const CART_HELPER = () => {
  const showToast = useCustomToast()
  const loggedInMobileNumber = loadState('ctxVal') || null
  const userState = useSelector((state) => state.user) || {}
  const cartState = useSelector((state) => state.cart) || {}
  const cityState = useSelector((state) => state.city)

  const handleGetCartItems = async () => {
    const payload = {
      phoneNumber: userState?.phoneNumber,
      bookingCreationNumber: loggedInMobileNumber,
    }
    const FINAL_API_PATH = CART_LIST_API
    const apiRes: any = await consumerRequest(FINAL_API_PATH, 'post', payload)

    if (apiRes?.status === true) {
      const currentPath =
        typeof window !== 'undefined' ? window.location.pathname : ''

      if (
        !isNonCityRoute(currentPath) &&
        apiRes?.data?.cartDtoList?.length > 0 &&
        !!apiRes?.data?.cityUuid &&
        (cityState?.currentCityObj?.uuid != apiRes?.data?.cityUuid ||
          isEmpty(cityState?.currentCityObj))
      ) {
        const filteredCityObj: any = cityState?.allCitiesList?.find(
          (item: any) => item?.uuid == apiRes?.data?.cityUuid
        )
        if (filteredCityObj?.uuid) {
          dispatch(
            updateCityData({ ...cityState, currentCityObj: filteredCityObj })
          )
          saveState('city', filteredCityObj)
        } else {
          showToast('warning', 'Cart City is not servicable now')
        }
      }
      return apiRes
    } else {
      console.error('Failed to get cart items', apiRes)
    }
  }
  const handleRestoreCartItems = async (
    phoneNumber: string | number,
    updatedCityUuid: string
  ) => {
    const payload = {
      phoneNumber,
      updatedCityUuid,
      bookingCreationNumber: loggedInMobileNumber,
    }
    const FINAL_API_PATH = CART_RESTORE_API
    const apiRes: any = await consumerRequest(FINAL_API_PATH, 'post', payload)
    if (apiRes?.status === true) {
      return apiRes
    } else {
      showToast(
        'danger',
        apiRes?.message || 'There is some issue in revising cart.'
      )
    }
  }

  const handleAddOrRemoveProductInCart = async (
    action: any,
    selectedUser: any,
    productDetail: any
  ) => {
    let patientDetail = { ...selectedUser }
    patientDetail.phoneNumber = userState?.phoneNumber
    delete patientDetail?.membersList

    const patientDetailDto =
      cartState?.activePatientDetailDto !== null &&
      Object?.values(cartState?.activePatientDetailDto)?.length > 0
        ? cartState?.activePatientDetailDto
        : patientDetail
    const productDetails = productDetail?.hasOwnProperty('productDto')
      ? productDetail?.productDto
      : productDetail
    const formData = [
      {
        action: action,
        cityUuid: cityState?.currentCityObj?.uuid,
        phoneNumber: userState?.phoneNumber,
        bookingCreationNumber: loggedInMobileNumber,
        patientDetailDto: { ...patientDetailDto },
        productDto: { ...productDetails },
      },
    ]

    if (Object?.values(formData[0]?.productDto)?.length === 0) {
      return
    }
    const payload = {
      cartElementDtoList: formData,
    }

    const apiRes: any = await consumerRequest(
      ADD_PRODUCT_IN_CART_API,
      'post',
      payload
    )

    if (apiRes?.status === true) {
      if (action === INSERT_ACTION) {
        trackEvent(eventConstants.ADD_TO_CART, {
          u_mb: loggedInMobileNumber,
          // product_code: productDetails?.code,
          city: cityState?.currentCityObj?.name || null,
          product_name: productDetails?.name,
          amount: productDetails?.price || 0,
          app: CONSUMER_WEB_PLATFORM,
          subsidiary: CURRENT_SUBSIDIARY,
        })
      }
      return apiRes
    } else {
      console.error('Failed to add product', apiRes)
    }
  }

  const handleClearCart = async (cartUuid: string) => {
    const payload = {
      cartUuid,
      phoneNumber: userState?.phoneNumber,
      bookingCreationNumber: loggedInMobileNumber,
    }
    const FINAL_API_PATH = DELETE_CART_API
    const apiRes: any = await consumerRequest(FINAL_API_PATH, 'post', payload)
    if (apiRes?.status === true) {
      return apiRes
    } else {
      console.error('Failed to remove cart', apiRes)
    }
  }

  return {
    handleGetCartItems,
    handleAddOrRemoveProductInCart,
    handleClearCart,
    handleRestoreCartItems,
  }
}

export default CART_HELPER
